import React, { useContext } from "react";

import { ThemeContext } from "../../contexts/ThemeContext";

import "./ServicesNew.css";
import { servicesData } from "../../data/servicesNewData";

function ServicesNew() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="education"
      id="services"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="education-body">
        <div className="education-description">
          <h1 style={{ color: theme.primary }}>Usługi fizjoterapeutyczne</h1>
          <h2 style={{ color: theme.primary }}>Opis</h2>
          <p style={{ color: theme.tertiary80 }}>
            {servicesData.description1}
            <br />
            <br />
            <b>Między innymi oferuję:</b>
            <br />
            <br />
          </p>
          <ul>
            {servicesData.services1.map((li, i) => (
              <li key={i}>
                <p style={{ color: theme.tertiary80 }}>{li}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="education-image">
          <img src={servicesData.image1} alt="education" />
        </div>
      </div>
      <div className="education-body">
        <div className="education-image">
          <img src={servicesData.image2} alt="education" />
        </div>
        <div className="education-description">
          <h1 style={{ color: theme.primary }}>Usługi trenerskie</h1>
          <h2 style={{ color: theme.primary }}>Opis</h2>
          <p style={{ color: theme.tertiary80 }}>
            {servicesData.description2}
            <br />
            <br />
            <b>Usługi:</b>
            <br />
            <br />
          </p>
          <ul>
            {servicesData.services2.map((li, i) => (
              <li key={i}>
                <p style={{ color: theme.tertiary80 }}>{li}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ServicesNew;
